<template>
	<div style="width: 100%;">
		<div style="display: flex;flex-direction: column;">
			<div style="text-align: left;font-weight: bold;font-size: 16px;margin-bottom: 60px;">当前规则适用于所有人员</div>
			<!-- <div style="margin-top: 10px;width: 37%;">
				<el-input type="textarea" cols="2" rows="6" placeholder="请输入内容" v-model="aduserList">
				</el-input>
			</div> -->
			<div v-for="(item, index) in showList" :key="index">
				<div style="margin-top: 12px;">
					<span>{{item.depTypeName}}:</span>
					<el-select v-model="item.aduserIds" multiple placeholder="请选择推广账号" size="mini" style="margin-left: 12px;width: 32%;" @change="changeSelect(index,item.aduserIds)">
						<el-option v-for="(item1,index1) in adUserIdList" :key="index1" :label="item1.aduserName" :value="item1.aduserId"></el-option>
					</el-select>
				</div>
				
			</div>
		</div>
		
		<div style="width: 160px; margin: 0 auto;margin-top: 60px;">
			
			<el-button type="primary" @click="saveAduserList">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TalkMultihospdep',
		props: ['csid'],
		data() {
			return {
				aduserList: [],
				showList: [],
				adUserIdList:[]
			}
		},
		mounted() {
			console.log('mounted TalkMultihospdep')
			this.getShowList()
			this.selectList()
		},
		methods:{
			// 获取现有推广账号规则
			async getShowList(){
				let api = '/manager/aduserRelation/getShowList'
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
					},
				})
				this.showList = response.data
				console.log("getShowList response",this.showList)
			},
			// 获取推广账号列表
			async selectList() {
				var api = "/manager/aduserRelation/selectList";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.adUserIdList = response.data
				} else {
					this.$message.error(response.desc);
				}
			},
			// 选择推广账号规则
			changeSelect(index,aduserIds) {
				this.showList[index].aduserIds = aduserIds
			},
			// 保存多科室规则
			async saveAduserList(){
				let relaMap = {}
				let dataList = JSON.parse(JSON.stringify(this.showList))
				for(let i = 0, len = dataList.length; i < len; i++){
					relaMap[dataList[i].depTypeId] = dataList[i].aduserIds
				}
				// console.log("relaMap",relaMap)
				var api = "/manager/aduserRelation/updateDepType";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						relaMap:relaMap
					},
				});
				// console.log("*****updateDepType *****", response);
				if (response.resultCode == 10000) {
					this.$message.success("更新多科室规则成功");
				} else {
					this.$message.error(response.desc);
				}
			},
			
		},
		watch: {
			csid: function(newVal, oldVal) {
				console.log(newVal, oldVal);
				this.getShowList(newVal)
			},
			
		},
	}
	
</script>

<style>
</style>
